import Vue from 'vue'
import axios from 'axios'
import * as R from 'ramda'
import * as moment from 'moment'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { split } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { createUploadLink } from 'apollo-upload-client'
import VueApollo from 'vue-apollo'
import mavonEditor from 'mavon-editor'
import VueI18n from 'vue-i18n'
import TextHighlight from 'vue-text-highlight'
import VuePhoneNumberInput from 'vue-phone-number-input'
import { Icon, Progress } from 'element-ui'

import 'mavon-editor/dist/css/index.css'
import 'font-awesome/scss/font-awesome.scss'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import enUS from 'vxe-table/lib/locale/lang/en-US'

Vue.config.productionTip = false

Vue.prototype.$http = axios

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(process.env.VUE_APP_JWT_NAME || 'VERGE_JWT_TOKEN')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const httpLink = createUploadLink({
  uri: process.env.VUE_APP_API_URL
})

const wsLink = new WebSocketLink({
  uri: process.env.VUE_APP_SUBSCRIPTION_URL as string,
  options: {
    reconnect: true
  }
})

const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
  },
  wsLink,
  httpLink
)

const apolloClient = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    }
  },
  connectToDevTools: true
})
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

declare module 'vue/types/vue' {
  interface Vue {
    $R: any;
    $moment: any;
    $axios: any;
  }
}

Object.defineProperties(Vue.prototype, {
  $R: {
    get () {
      return R
    }
  },
  $moment: {
    get () {
      return moment
    }
  },
  $axios: {
    get () {
      return axios
    }
  }
})

const messages = {
  zh_CN: {
    ...zhCN
  },
  en_US: {
    ...enUS
  }
}

Vue.use(VueI18n)
Vue.use(Icon)

Vue.use(Progress)

const i18n = new VueI18n({
  locale: 'en_US',
  messages
})

Vue.use(VueApollo)
Vue.use(mavonEditor)
Vue.use(VXETable, {
  i18n: (key, args) => i18n.t(key, args)
})
Vue.component('text-highlight', TextHighlight)
Vue.component('VuePhoneNumberInput', VuePhoneNumberInput)

new Vue({
  router,
  store,
  vuetify,
  apolloProvider,
  i18n,
  render: h => h(App)
}).$mount('#app')
